import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { AuditAlertResponse } from "../../auditLog.types";
import { requestAcknowledgeAuditAlert } from "./acknowledgeAuditAlert.request";

const useAcknowledgeAuditAlert = (
  options?: MutationOptions<AuditAlertResponse, ApiServiceError<ApiError>>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (alertId: string) => requestAcknowledgeAuditAlert(alertId),
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({ queryKey: ["audit-alerts"] });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useAcknowledgeAuditAlert;
